import axios from "axios";

import initialConfig from "@configs/initialConfig";
import MySwalBlockUi from "@pageUtils/block-ui";

// ** GET Products
export const getCourses = (params) => {
  return (dispatch) => {
    return axios
      .post(initialConfig.ipServer.concat("/api/payment/get/course/payment"), {
        params,
      })
      .then((res) => {
        dispatch({ type: "GET_PAYMENT_COURSES", data: res.data, params });
      });
  };
};

export const getCourseDetail = (params) => {
  const mySwal = MySwalBlockUi();
  return (dispatch) => {
    return axios
      .post(initialConfig.ipServer.concat("/api/payment/get/course/payment"), {
        params,
      })
      .then((res) => {
        mySwal.close();
        dispatch({
          type: "GET_PAYMENT_COURSE_DETAIL",
          data: res.data,
          params,
        });
      });
  };
};

export const saveCourseRegistration = (params) => {
  const mySwal = MySwalBlockUi();
  const {
    courseId,
    userId,
    transactionCourseUserStatus,
    callBackFunction,
  } = params;
  axios
    .post(
      initialConfig.ipServer.concat("/api/payment/save/course/registration"),
      {
        courseId: courseId,
        userId: userId,
        transactionCourseUserStatus: transactionCourseUserStatus,
      }
    )
    .then((res) => {
      mySwal.close();
      callBackFunction({
        type: "SAVE_PAYMENT_COURSE_REGISTRATION",
        data: res.data,
      });
    });
};

export const saveTransactionPaymentProof = (params) => {
  const mySwal = MySwalBlockUi();
  const {
    transactionCourseUserId,
    amount,
    courseId,
    createBy,
    createDate,
    flag,
    id,
    imageProof,
    status,
    updateBy,
    updateDate,
    userId,
    callBackFunction,
    fileType,
    transferDate,
    transferTime,
    bankName,
  } = params;
  const transactionPaymentProof = {
    transactionCourseUserId: transactionCourseUserId,
    amount: amount,
    courseId: courseId,
    createBy: createBy,
    createDate: createDate,
    flag: flag,
    id: id,
    imageProof: imageProof,
    status: status,
    updateBy: updateBy,
    updateDate: updateDate,
    userId: userId,
    fileType: fileType,
  };
  axios
    .post(
      initialConfig.ipServer.concat(
        "/api/payment/save/transaction/payment/proof"
      ),
      {
        transactionPaymentProof: transactionPaymentProof,
        transferDate : transferDate,
        transferTime : transferTime,
        bankNameTransfer : bankName,
      }
    )
    .then((res) => {
      mySwal.close();
      callBackFunction({
        type: "SAVE_PAYMENT_TRANSACTION_PAYMENT_PROOF",
        data: res.data,
      });
    });
};
